module.exports = __webpack_public_path__ + "static/media/es.8413cd53.svg";